module.exports = __webpack_public_path__ + "img/vandiverhall-h-474x356.441dc846.jpg";